import { baseUrl } from 'volto-ebc-radiomec/utils/api';

export type PodcastsPageItem = {
  '@id': string;
  audio?: string;
  description?: string;
  effective?: string;
  image?: string;
  programTitle?: string;
  programUrl?: string;
  title: string;
};

export async function getPodcastsPageItems({
  page = 0,
  search = '',
  program = '',
}: {
  page?: number;
  search?: string;
  program?: string;
} = {}): Promise<PodcastsPageItem[]> {
  try {
    const params = new URLSearchParams();

    params.set('page', String(page));

    if (search.trim()) {
      params.set('SearchableText', search.trim());
    }

    if (program && program !== 'Todos') {
      params.set('program', program);
    }

    const response = await fetch(
      `${baseUrl}/@content-latest-podcasts?${params.toString()}`,
    );

    if (!response.ok) {
      throw new Error(
        `Erro ao buscar podcasts: ${response.status} ${response.statusText}`,
      );
    }

    const data = await response.json();
    const items = Array.isArray(data) ? data : [];

    return items.map((item: any) => ({
      '@id': item?.['@id'] ?? '',
      title: item?.title ?? '',
      description: item?.description ?? '',
      image: item?.image ?? '',
      audio: item?.audio ?? '',
      effective: item?.effective ?? '',
      programTitle: item?.programTitle ?? 'Podcast',
      programUrl: item?.programUrl ?? '',
    }));
  } catch (error) {
    console.error('Falha ao buscar podcasts da página:', error);
    return [];
  }
}
